const langHomeIndex = {
	title: {
		tag: 'home.index.title',
		fr: 'Vous avez un compte ?',
		en: 'You have an account ?',
	},
	btn_login: {
		tag: 'home.index.btn_login',
		fr: 'Je me connecte à mon compte',
		en: 'I login with my account',
	},
};

export default langHomeIndex;
